module.exports = __webpack_public_path__ + "static/BobQianResume-c5ff93046e7c0bc362a63602d3b87a90.pdf";